import { create } from 'zustand';

/**
 * The simplified app's search palette (#1514): open or not. Opened by ⌘K and the
 * sidebar's Search.
 */
interface SearchPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSearchPalette = create<SearchPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export const openSearchPalette = (): void => useSearchPalette.getState().setOpen(true);
